import { getEnv } from 'config/env';
import { Env } from 'types';

const urlMap: Record<string, string> = {
  [Env.DEV]: 'http://localhost:4566/doc.tonsbergseilforening/',
  [Env.PROD]: 'https://doc.tonsbergseilforening.no/',
  [Env.TEST]: '🤷‍♂️',
};

export const docUrl = () => urlMap[getEnv()];
